import { render, staticRenderFns } from "./BatchAdmin.vue?vue&type=template&id=93919d38&scoped=true&"
import script from "./BatchAdmin.vue?vue&type=script&lang=js&"
export * from "./BatchAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BatchAdmin.vue?vue&type=style&index=0&id=93919d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93919d38",
  null
  
)

export default component.exports